var identity = require('./identity');

/**
 * Converts `value` to a function if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Function} Returns the function.
 */
function toFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = toFunction;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_toFunction.js
 ** module id = 275
 ** module chunks = 0
 **/